import { gh, isExecute, vueDefineComponent } from '@syncfusion/ej2-vue-base';
import { isNullOrUndefined } from '@syncfusion/ej2-base';
export let SplitButtonItemsDirective = vueDefineComponent({
    inject: { custom: { default: null } },
    render(createElement) {
        if (!isExecute) {
            let h = !isExecute ? gh : createElement;
            let slots = null;
            if (!isNullOrUndefined(this.$slots.default)) {
                slots = !isExecute ? this.$slots.default() : this.$slots.default;
            }
            return h('div', { class: 'e-directive' }, slots);
        }
        return;
    },
    updated() {
        if (!isExecute && this.custom) {
            this.custom();
        }
    },
    methods: {
        getTag() {
            return 'e-splitbuttonitems';
        }
    }
});
export const SplitButtonItemsPlugin = {
    name: 'e-splitbuttonitems',
    install(Vue) {
        Vue.component(SplitButtonItemsPlugin.name, SplitButtonItemsDirective);
    }
};
export let SplitButtonItemDirective = vueDefineComponent({
    render() {
        return;
    },
    methods: {
        getTag() {
            return 'e-splitbuttonitem';
        }
    }
});
export const SplitButtonItemPlugin = {
    name: 'e-splitbuttonitem',
    install(Vue) {
        Vue.component(SplitButtonItemPlugin.name, SplitButtonItemDirective);
    }
};
